var _defs, _polygon, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _g13, _polyline, _g14, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlantLayoutModjoul2NdFloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1224 792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill: none;\n      }\n\n      .cls-1, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-7 {\n        stroke-linejoin: round;\n      }\n\n      .cls-7, .cls-8, .cls-9 {\n        fill: #66aa7d;\n      }\n\n      .cls-7, .cls-8, .cls-9, .cls-5 {\n        stroke: #010101;\n      }\n\n      .cls-7, .cls-2 {\n        stroke-width: .75px;\n      }\n\n      .cls-8 {\n        stroke-width: .5px;\n      }\n\n      .cls-8, .cls-2, .cls-9, .cls-3, .cls-4, .cls-5 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke: #231f20;\n      }\n\n      .cls-3 {\n        stroke-width: 2px;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "521.2 158.1 854.54 158.1 854.54 201.65 521.2 201.65 521.2 284.32 854.54 284.32 854.54 368.76 521.2 368.76 521.2 454.09 854.54 454.09 854.54 575.87 521.2 575.87 521.2 694.98 143.43 694.98 143.43 158.1 305.2 158.1 305.2 116.32 518.54 116.32 521.2 158.1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 526.21,
    y: 350.87,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 531.1,
    y1: 350.24,
    x2: 531.1,
    y2: 360.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 526.01,
    y1: 355.57,
    x2: 535.8,
    y2: 355.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 536.63,
    y: 350.87,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 541.34,
    y1: 350.24,
    x2: 541.34,
    y2: 360.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 536.25,
    y1: 355.57,
    x2: 546.04,
    y2: 355.57
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 527.23,
    y: 360.67,
    width: 2.98,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 542.22,
    y: 360.67,
    width: 2.98,
    height: 5.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 552.71,
    y: 350.87,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 557.6,
    y1: 350.24,
    x2: 557.6,
    y2: 360.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 552.51,
    y1: 355.57,
    x2: 562.31,
    y2: 355.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 563.13,
    y: 350.87,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 567.84,
    y1: 350.24,
    x2: 567.84,
    y2: 360.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 562.75,
    y1: 355.57,
    x2: 572.54,
    y2: 355.57
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 553.73,
    y: 360.67,
    width: 2.98,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 568.72,
    y: 360.67,
    width: 2.98,
    height: 5.68
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 582.62,
    y: 350.44,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 587.52,
    y1: 349.81,
    x2: 587.52,
    y2: 359.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 582.43,
    y1: 355.14,
    x2: 592.22,
    y2: 355.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 593.05,
    y: 350.44,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 597.75,
    y1: 349.81,
    x2: 597.75,
    y2: 359.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 592.66,
    y1: 355.14,
    x2: 602.45,
    y2: 355.14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 583.65,
    y: 360.24,
    width: 2.98,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 598.63,
    y: 360.24,
    width: 2.98,
    height: 5.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 606.41,
    y: 350.44,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 611.31,
    y1: 349.81,
    x2: 611.31,
    y2: 359.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 606.22,
    y1: 355.14,
    x2: 616.01,
    y2: 355.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 616.84,
    y: 350.44,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 621.54,
    y1: 349.81,
    x2: 621.54,
    y2: 359.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 616.45,
    y1: 355.14,
    x2: 626.24,
    y2: 355.14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 607.44,
    y: 360.24,
    width: 2.98,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 622.42,
    y: 360.24,
    width: 2.98,
    height: 5.68
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 634.89,
    y: 350.44,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 639.79,
    y1: 349.81,
    x2: 639.79,
    y2: 359.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 634.7,
    y1: 355.14,
    x2: 644.49,
    y2: 355.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 645.32,
    y: 350.44,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 650.02,
    y1: 349.81,
    x2: 650.02,
    y2: 359.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 644.93,
    y1: 355.14,
    x2: 654.72,
    y2: 355.14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 635.92,
    y: 360.24,
    width: 2.98,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 650.9,
    y: 360.24,
    width: 2.98,
    height: 5.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 658.69,
    y: 350.44,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 663.58,
    y1: 349.81,
    x2: 663.58,
    y2: 359.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 658.49,
    y1: 355.14,
    x2: 668.28,
    y2: 355.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 669.11,
    y: 350.44,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 673.81,
    y1: 349.81,
    x2: 673.81,
    y2: 359.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 668.72,
    y1: 355.14,
    x2: 678.52,
    y2: 355.14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 659.71,
    y: 360.24,
    width: 2.98,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 674.69,
    y: 360.24,
    width: 2.98,
    height: 5.68
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 689.23,
    y: 351.07,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 694.13,
    y1: 350.44,
    x2: 694.13,
    y2: 360.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 689.04,
    y1: 355.77,
    x2: 698.83,
    y2: 355.77
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 699.66,
    y: 351.07,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 704.36,
    y1: 350.44,
    x2: 704.36,
    y2: 360.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 699.27,
    y1: 355.77,
    x2: 709.06,
    y2: 355.77
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 690.26,
    y: 360.87,
    width: 2.98,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 705.24,
    y: 360.87,
    width: 2.98,
    height: 5.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 713.03,
    y: 351.07,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 717.92,
    y1: 350.44,
    x2: 717.92,
    y2: 360.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 712.83,
    y1: 355.77,
    x2: 722.62,
    y2: 355.77
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 723.45,
    y: 351.07,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 728.15,
    y1: 350.44,
    x2: 728.15,
    y2: 360.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 723.06,
    y1: 355.77,
    x2: 732.86,
    y2: 355.77
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 714.05,
    y: 360.87,
    width: 2.98,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 729.03,
    y: 360.87,
    width: 2.98,
    height: 5.68
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 740.97,
    y: 350.44,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 745.87,
    y1: 349.81,
    x2: 745.87,
    y2: 359.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 740.78,
    y1: 355.14,
    x2: 750.57,
    y2: 355.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 751.4,
    y: 350.44,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 756.1,
    y1: 349.81,
    x2: 756.1,
    y2: 359.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 751.01,
    y1: 355.14,
    x2: 760.8,
    y2: 355.14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 742,
    y: 360.24,
    width: 2.98,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 756.98,
    y: 360.24,
    width: 2.98,
    height: 5.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 764.77,
    y: 350.44,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 769.66,
    y1: 349.81,
    x2: 769.66,
    y2: 359.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 764.57,
    y1: 355.14,
    x2: 774.36,
    y2: 355.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 775.19,
    y: 350.44,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 779.9,
    y1: 349.81,
    x2: 779.9,
    y2: 359.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 774.81,
    y1: 355.14,
    x2: 784.6,
    y2: 355.14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 765.79,
    y: 360.24,
    width: 2.98,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 780.77,
    y: 360.24,
    width: 2.98,
    height: 5.68
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 794.49,
    y: 350.44,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 799.38,
    y1: 349.81,
    x2: 799.38,
    y2: 359.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 794.29,
    y1: 355.14,
    x2: 804.09,
    y2: 355.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 804.92,
    y: 350.44,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 809.62,
    y1: 349.81,
    x2: 809.62,
    y2: 359.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 804.53,
    y1: 355.14,
    x2: 814.32,
    y2: 355.14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 795.51,
    y: 360.24,
    width: 2.98,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 810.5,
    y: 360.24,
    width: 2.98,
    height: 5.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 818.28,
    y: 350.44,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 823.18,
    y1: 349.81,
    x2: 823.18,
    y2: 359.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 818.09,
    y1: 355.14,
    x2: 827.88,
    y2: 355.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 828.71,
    y: 350.44,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 833.41,
    y1: 349.81,
    x2: 833.41,
    y2: 359.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 828.32,
    y1: 355.14,
    x2: 838.11,
    y2: 355.14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 819.3,
    y: 360.24,
    width: 2.98,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 834.29,
    y: 360.24,
    width: 2.98,
    height: 5.68
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 529.39,
    y: 458.04,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 534.28,
    y1: 457.41,
    x2: 534.28,
    y2: 467.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 529.19,
    y1: 462.74,
    x2: 538.98,
    y2: 462.74
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 539.81,
    y: 458.04,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 544.52,
    y1: 457.41,
    x2: 544.52,
    y2: 467.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 539.43,
    y1: 462.74,
    x2: 549.22,
    y2: 462.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 553.18,
    y: 458.04,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 558.08,
    y1: 457.41,
    x2: 558.08,
    y2: 467.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 552.99,
    y1: 462.74,
    x2: 562.78,
    y2: 462.74
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 563.61,
    y: 458.04,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 568.31,
    y1: 457.41,
    x2: 568.31,
    y2: 467.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 563.22,
    y1: 462.74,
    x2: 573.01,
    y2: 462.74
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 581.6,
    y: 457.73,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 586.49,
    y1: 457.1,
    x2: 586.49,
    y2: 466.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 581.4,
    y1: 462.43,
    x2: 591.19,
    y2: 462.43
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 592.02,
    y: 457.73,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 596.72,
    y1: 457.1,
    x2: 596.72,
    y2: 466.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 591.64,
    y1: 462.43,
    x2: 601.43,
    y2: 462.43
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 605.39,
    y: 457.73,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 610.28,
    y1: 457.1,
    x2: 610.28,
    y2: 466.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 605.19,
    y1: 462.43,
    x2: 614.99,
    y2: 462.43
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 615.82,
    y: 457.73,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 620.52,
    y1: 457.1,
    x2: 620.52,
    y2: 466.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 615.43,
    y1: 462.43,
    x2: 625.22,
    y2: 462.43
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 635.43,
    y: 457.61,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 640.33,
    y1: 456.98,
    x2: 640.33,
    y2: 466.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 635.24,
    y1: 462.31,
    x2: 645.03,
    y2: 462.31
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 645.86,
    y: 457.61,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 650.56,
    y1: 456.98,
    x2: 650.56,
    y2: 466.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 645.47,
    y1: 462.31,
    x2: 655.26,
    y2: 462.31
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 659.22,
    y: 457.61,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 664.12,
    y1: 456.98,
    x2: 664.12,
    y2: 466.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 659.03,
    y1: 462.31,
    x2: 668.82,
    y2: 462.31
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 669.65,
    y: 457.61,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 674.35,
    y1: 456.98,
    x2: 674.35,
    y2: 466.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 669.26,
    y1: 462.31,
    x2: 679.05,
    y2: 462.31
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 688.67,
    y: 457.49,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 693.56,
    y1: 456.86,
    x2: 693.56,
    y2: 466.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 688.47,
    y1: 462.19,
    x2: 698.27,
    y2: 462.19
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 699.1,
    y: 457.49,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 703.8,
    y1: 456.86,
    x2: 703.8,
    y2: 466.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 698.71,
    y1: 462.19,
    x2: 708.5,
    y2: 462.19
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 712.46,
    y: 457.49,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 717.36,
    y1: 456.86,
    x2: 717.36,
    y2: 466.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 712.27,
    y1: 462.19,
    x2: 722.06,
    y2: 462.19
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 722.89,
    y: 457.49,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 727.59,
    y1: 456.86,
    x2: 727.59,
    y2: 466.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 722.5,
    y1: 462.19,
    x2: 732.29,
    y2: 462.19
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 740.04,
    y: 457.37,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 744.93,
    y1: 456.74,
    x2: 744.93,
    y2: 466.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 739.84,
    y1: 462.07,
    x2: 749.63,
    y2: 462.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 750.46,
    y: 457.37,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 755.16,
    y1: 456.74,
    x2: 755.16,
    y2: 466.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 750.07,
    y1: 462.07,
    x2: 759.87,
    y2: 462.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 767.23,
    y: 457.25,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 772.12,
    y1: 456.62,
    x2: 772.12,
    y2: 466.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 767.03,
    y1: 461.95,
    x2: 776.83,
    y2: 461.95
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 777.66,
    y: 457.25,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 782.36,
    y1: 456.62,
    x2: 782.36,
    y2: 466.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 777.27,
    y1: 461.95,
    x2: 787.06,
    y2: 461.95
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 792.87,
    y: 457.19,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 797.77,
    y1: 456.56,
    x2: 797.77,
    y2: 466.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 792.68,
    y1: 461.89,
    x2: 802.47,
    y2: 461.89
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 803.3,
    y: 457.19,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 808,
    y1: 456.56,
    x2: 808,
    y2: 466.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 802.91,
    y1: 461.89,
    x2: 812.7,
    y2: 461.89
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 820.06,
    y: 457.07,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 824.96,
    y1: 456.44,
    x2: 824.96,
    y2: 466.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 819.87,
    y1: 461.77,
    x2: 829.66,
    y2: 461.77
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 830.49,
    y: 457.07,
    width: 9.4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 835.19,
    y1: 456.44,
    x2: 835.19,
    y2: 466.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 830.1,
    y1: 461.77,
    x2: 839.89,
    y2: 461.77
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 855.46,
    y1: 334.35,
    x2: 855.46,
    y2: 385.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 381.09,
    x2: 862.94,
    y2: 381.09
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 379.29,
    x2: 862.94,
    y2: 379.29
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 377.72,
    x2: 862.94,
    y2: 377.72
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 375.74,
    x2: 862.94,
    y2: 375.74
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 374.16,
    x2: 862.94,
    y2: 374.16
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 372.18,
    x2: 862.94,
    y2: 372.18
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 370.2,
    x2: 862.94,
    y2: 370.2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 368.87,
    x2: 862.94,
    y2: 368.87
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 367.24,
    x2: 862.94,
    y2: 367.24
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 365.26,
    x2: 862.94,
    y2: 365.26
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 363.51,
    x2: 862.94,
    y2: 363.51
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 361.76,
    x2: 862.94,
    y2: 361.76
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 360.24,
    x2: 862.94,
    y2: 360.24
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 358.27,
    x2: 862.94,
    y2: 358.27
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 350.81,
    x2: 862.94,
    y2: 350.81
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 348.89,
    x2: 862.94,
    y2: 348.89
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 347.38,
    x2: 862.94,
    y2: 347.38
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 345.57,
    x2: 862.94,
    y2: 345.57
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 343.48,
    x2: 862.94,
    y2: 343.48
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 341.79,
    x2: 862.94,
    y2: 341.79
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 340.1,
    x2: 862.94,
    y2: 340.1
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 338.41,
    x2: 862.94,
    y2: 338.41
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 855.46,
    y1: 336.72,
    x2: 862.94,
    y2: 336.72
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "862.94 385.05 862.94 326.87 855.09 326.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M855.09,328.18h5.81v.36c0,3.21-2.6,5.81-5.81,5.81h0"
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "854.54 495.92 520.13 495.92 520.13 529.94 854.54 529.94"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "862.39 511.65 862.39 453.47 854.54 453.47"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 854.91,
    y1: 460.95,
    x2: 854.91,
    y2: 511.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 507.7,
    x2: 862.39,
    y2: 507.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 505.89,
    x2: 862.39,
    y2: 505.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 504.32,
    x2: 862.39,
    y2: 504.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 502.34,
    x2: 862.39,
    y2: 502.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 500.77,
    x2: 862.39,
    y2: 500.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 498.79,
    x2: 862.39,
    y2: 498.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 496.81,
    x2: 862.39,
    y2: 496.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 495.47,
    x2: 862.39,
    y2: 495.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 493.84,
    x2: 862.39,
    y2: 493.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 491.86,
    x2: 862.39,
    y2: 491.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 490.11,
    x2: 862.39,
    y2: 490.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 488.36,
    x2: 862.39,
    y2: 488.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 486.84,
    x2: 862.39,
    y2: 486.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 484.87,
    x2: 862.39,
    y2: 484.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 477.42,
    x2: 862.39,
    y2: 477.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 475.49,
    x2: 862.39,
    y2: 475.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 473.98,
    x2: 862.39,
    y2: 473.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 472.17,
    x2: 862.39,
    y2: 472.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 470.08,
    x2: 862.39,
    y2: 470.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 468.39,
    x2: 862.39,
    y2: 468.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 466.7,
    x2: 862.39,
    y2: 466.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 465.01,
    x2: 862.39,
    y2: 465.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 854.91,
    y1: 463.32,
    x2: 862.39,
    y2: 463.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M854.54,454.78h5.81v.36c0,3.21-2.6,5.81-5.81,5.81h0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M854.54,455.01h5.81v.36c0,3.21-2.6,5.81-5.81,5.81h0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 844.29,
    y: 496.65,
    width: 23.15,
    height: 32.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantLayoutModjoul2NdFloor);
export default __webpack_public_path__ + "static/media/Plant Layout - Modjoul 2nd Floor.cca625daf026318c3e69b3f18f25cfad.svg";
export { ForwardRef as ReactComponent };